import { updateSample } from "../../../actions/samples";

const useSamples = (samples, setSamples, selectedSamples) => {
  const hookGetSamples = () => {
    return samples;
  };

  const hookGetSampleByWell = (well) => {
    return samples.find((sample) => sample.well === well);
  };

  const hookAssignPrimer = (sampleId, primerId) => {
    setSamples((samples) => {
      return samples.map((sample) => {
        if (sample._id === sampleId) {
          updateSample(sample._id, {
            primer: primerId
          })
          return {
            ...sample,
            primer: primerId,
          };
        } else {
          return sample;
        }
      });
    });
  };

  const hookSwapPrimer = (oldPrimerId, newPrimerId) => {
    setSamples((samples) => {
      return samples.map((sample) => {
        if (sample.primer === oldPrimerId) {
          updateSample(sample._id, {
            primer: newPrimerId
          })
          return {
            ...sample,
            primer: newPrimerId,
          };
        } else {
          return sample;
        }
      });
    });
  };

  const hookMoveSample = (toWellIndex, sample) => {
    setSamples((samples) => {
      const newSamples = [...samples];
      if (selectedSamples.has(sample._id)) {
        const actualSelectedSamples = [...selectedSamples].map((id) => {
          return samples.find((sample) => sample._id === id);
        });
        const sortedSelectedSamples = actualSelectedSamples.sort((a, b) => {
          if (a.well < b.well) {
            return -1;
          } else if (a.well > b.well) {
            return 1;
          }
          return 0;
        });
        let offset = 0;
        for (const selectedSample of sortedSelectedSamples) {
          const wellToMoveTo = toWellIndex + offset;
          for (let i = 0; i < newSamples.length; i++) {
            // if there is a sample in the well we want to move to
            if (newSamples[i].well === wellToMoveTo) {
              // we swap positions
              updateSample(newSamples[i]._id, {
                well: selectedSample.well
              })
              newSamples[i].well = selectedSample.well;
            }
          }
          for (let i = 0; i < newSamples.length; i++) {
            // we find the sample we want to move
            if (newSamples[i]._id === selectedSample._id) {
              updateSample(newSamples[i]._id, {
                well: wellToMoveTo
              })
              newSamples[i].well = wellToMoveTo;
            }
          }
          offset += 1;
        }
      } else {
        for (let i = 0; i < newSamples.length; i++) {
          // if there is a sample in the well we want to move to
          if (newSamples[i].well === toWellIndex) {
            updateSample(newSamples[i]._id, {
              well: sample.well
            })
            newSamples[i].well = sample.well;
          }
        }
        for (let i = 0; i < newSamples.length; i++) {
          // found the sample we want to move
          if (newSamples[i]._id === sample._id) {
            updateSample(newSamples[i]._id, {
              well: toWellIndex,
            })
            newSamples[i].well = toWellIndex;
          }
        }
      }
      return newSamples;
    });
  };

  return {
    getSamples: hookGetSamples,
    getSampleByWell: hookGetSampleByWell,
    assignPrimer: hookAssignPrimer,
    swapPrimer: hookSwapPrimer,
    moveSample: hookMoveSample,
  };
};

export default useSamples;
